angular.module('app').directive("gameIdAutocomplete", ["casinoGameService", '$timeout', 'errorHandler', function (casinoGameService, $timeout, errorHandler) {
    return {
        restrict: 'E',
        replace: 'true',
        templateUrl: "views/templates/id_autocomplete/id_autocomplete.html",
        link: function ($scope, element, attr) {
            $scope.showSearchResults = false;
            var selectedSearchTerm;
            var value;
            var callMethod = attr.isReport? getCasinoGames: getSkinGames;
            if (!attr.isReport) {
                value = (Array.isArray($scope.pageData.customFields[$scope.$index].value) && $scope.pageData.customFields[$scope.$index].value[0]) || $scope.pageData.customFields[$scope.$index].value;
            } else {
                $scope.isReport = true;
            }
            if (value && !isNaN(value)) {
                casinoGameService.getSkinGames({gameIds: value}).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.games = angular.copy(response.skinGames).map(function (item) {
                                $scope.selectGame({
                                    id: item.game.id,
                                    fullTitle: item.game.name + ' (' + item.game.provider_title + ')' + ' (' + (item.game.is_mobile == 1? 'Mobile)': 'Web)' ),
                                    title: item.game.name,
                                    externalId: item.game.extearnal_game_id
                                });
                            });
                            $scope.showSearchResults = true;
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    });
            }

            function getSkinGames(filtersData) {
                casinoGameService.getSkinGames(filtersData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.games = angular.copy(response.skinGames).map(function (item) {
                                return {
                                    id: item.game.id,
                                    fullTitle: item.game.name + ' (' + item.game.provider_title + ')' + ' (' + (item.game.is_mobile == 1? 'Mobile)': 'Web)' ),
                                    title: item.game.name,
                                    externalId: item.game.extearnal_game_id
                                }
                            });
                            $scope.showSearchResults = true;
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    });
            }

            function getCasinoGames(filtersData) {
                casinoGameService.get(filtersData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.games = angular.copy(response.games).map(function (item) {
                                return {
                                    id: item.id,
                                    fullTitle: item.name + ' (' + item.provider + ')' + ' (' + (item.is_mobile == 1? 'Mobile)': 'Web)' ),
                                    title: item.name,
                                    externalId: item.extearnal_game_id
                                }
                            });
                            $scope.showSearchResults = true;
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    });
            }
            function doSearch(term) {
                if ($scope.notCallSearch) {
                    $scope.notCallSearch = false;
                    return;
                }

                if(term !== selectedSearchTerm) {
                    if (attr.isReport) {
                        $scope.selectSkinGame(null);
                    } else {
                        $scope.pageData.customFields[$scope.$index].value = "";
                    }
                }
                if (term && term.length > 2 && term !== selectedSearchTerm) {
                    var filtersData = {};
                    filtersData.search = term;
                    if (attr.isReport) {
                        filtersData.status = "published";
                        filtersData.count = "all";
                    }
                   callMethod(filtersData);
                } else {
                    $scope.showSearchResults = false;
                }

            }

            /**
             * Monitors search field and starts searching when user stopped typing
             */
            var currentSearchTermValue, searchWatcherPromise;

            function searchWatcher() {
                if ($scope.searchTerm && currentSearchTermValue !== $scope.searchTerm) {
                    currentSearchTermValue = $scope.searchTerm;
                    if (searchWatcherPromise) {
                        $timeout.cancel(searchWatcherPromise);
                    }
                    searchWatcherPromise = $timeout(searchWatcher, 100);
                } else {
                    doSearch($scope.searchTerm);
                }


            }

            $scope.$watch('searchTerm', searchWatcher);

            /**
             * performs the search when keypress event is 'enter'(13)
             * @param event
             */
            $scope.searchEnter = function searchEnter(event) {
                if (event.which === 13) {
                    searchWatcher();
                }
            };

            function arrowDownListener() {
                if ($scope.searchTerm.length && $scope.games.length) {
                    var highlightedElements = $scope.games.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        var item = highlightedElements[0];
                        item.isHighlighted = false;
                        var index = $scope.games.indexOf(item);
                        if (index < $scope.games.length - 1) {
                            $scope.games[index + 1].isHighlighted = true;
                        } else {
                            $scope.games[0].isHighlighted = true;
                        }
                    } else {
                        $scope.games[0].isHighlighted = true;
                    }
                    $timeout(function () {
                        $scope.$apply();
                    })
                }
            }

            function arrowUpListener() {
                if ($scope.searchTerm.length && $scope.games.length) {
                    var highlightedElements = $scope.games.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        var item = highlightedElements[0];
                        item.isHighlighted = false;
                        var index = $scope.games.indexOf(item);
                        if (index > 0) {
                            $scope.games[index - 1].isHighlighted = true;
                        } else {
                            $scope.games[$scope.games.length - 1].isHighlighted = true;
                        }
                    }
                    $timeout(function () {
                        $scope.$apply();
                    })
                }
            }

            /**
             * Searching game selecting by enter listener
             */
            function enterListener() {
                if ($scope.searchTerm.length && $scope.games.length) {
                    var highlightedElements = $scope.games.filter(function (value) {
                        return value.isHighlighted;
                    });
                    if (highlightedElements.length > 0) {
                        $scope.selectGame(highlightedElements[0]);
                    }
                }
            }

            /**
             * Select game
             * @param game
             */
            $scope.selectGame = function selectGame(game) {
                $scope.searchTerm = game.title;
                if (attr.isReport) {
                   $scope.selectSkinGame(game.id);
                } else {
                    $scope.pageData.customFields[$scope.$index].value = [game.id, game.externalId];
                }
                $scope.showSearchResults = false;
                selectedSearchTerm = game.title;
                $timeout(function () {
                    $scope.$apply();
                })
            };


            function keyDownListener(event) {
                var keyCode = event.keyCode;
                if (keyCode === 38) {
                    arrowUpListener();
                } else if (keyCode === 40) {
                    arrowDownListener();
                } else if (keyCode === 13) {
                    event.preventDefault();
                    enterListener();
                }
            }

            document.body.addEventListener('keydown', keyDownListener);
            $scope.$on("$destroy", function (event) {
                document.body.removeEventListener('keydown', keyDownListener);
            });
        }
    };
}]);
